module.exports = __webpack_public_path__ + "img/burger-soda.d82f04d8.svg";